import API from "..";

export interface UpdateChannelData {
  channelName?: string;
}

export const updateChannel = async (id: string, data: UpdateChannelData) => API.put<string>(`/channel/${id}`, data);